export enum FeaturesRoutingEnum {
  Home = '',
  HomeB = 'accueil',
  HomeC = 'home',
  Events = 'evenements',
  Jobs = 'emplois',
  StudentJobs = 'jobs-etudiants',
  SummerJobs = 'jobs-ete',
  Internships = 'stages',
  CGU = 'cgu',
  Privacy = 'confidentialite',
  Accessibility = 'accessibilite',
  Cookies = 'cookies',
  LegalMentions = 'mentions-legales',
  Employers = 'je-recrute',
  NotFound = '404',
  Young = 'espace-jeune',
  Article = 'article',
  Tags = 'tags',
  Companies = 'entreprises',
  CivicService = 'service-civique',
  Promo1618 = 'promo-16-18-afpa',
  Visiotalent = 'ma-video-de-motivation',
  PoleEmploiMaintenance = 'maintenance-pole-emploi',
  AccessHelps = 'mes-aides',
  CreateCompany = 'entreprendre',
  Mentoring = 'mentorat',
  Apprentice = 'apprentissage',
  Trainings = 'formations',
  TrainingObligation = '16-18-obligation-formation',
  Commitment = 'engagement',
  Volunteer = 'benevolat',
  Sitemap = 'plan-du-site',
  JobDating = 'jobdating',
  YouthInfoCenter = 'accompagnement',
  Partners = 'partenaires',
  Marseille = 'entrepreneuriat-marseille',
  CEJ = 'contrat-engagement-jeune',
  DiagorienteCv = 'creer-mon-cv',
  DiagorienteInterests = 'trouver-mon-metier',
}

export enum FragmentsEnum {
  CommitmentOtherOperator = 'autres-dispositifs',
}
